import { useDispatch, useSelector } from "react-redux";
import { setOpenChoiceComponentAR, setOpenChoiceSystem, setOpenEnteringDataAR, setOpenMainMenu, setOpenRevenueModule, setSelectedSystem } from "../Reducer/ModalSlice";
import { useState } from "react";
import { roleId } from "../Components/Constants/app";

function ChoiceSystem() {
    const User = useSelector(state => state.UserSlice.User)

    const [CancelTouch, setCancelTouch] = useState(false)

    const dispatch = useDispatch()

    return(
        <div
        className="ModalGlobalDiv"
        >
            <div
            className="ChoiceSystemColumnDiv"
            >
                <button
                className="ChoiceSystemMainButton"
                onClick={(async () => {
                    await dispatch(setOpenMainMenu(true))
                    dispatch(setSelectedSystem('FOT'))
                    dispatch(setOpenChoiceSystem(false))
                })}
                onTouchStart={() => {
                    setCancelTouch(false)
                }}
                onTouchMove={() => {
                    setCancelTouch(true)
                }}
                onTouchCancel={() => {
                    setCancelTouch(true)
                }}
                onTouchEnd={(async (event) => {
                    event.preventDefault()
                    if(!CancelTouch)
                    {
                        await dispatch(setOpenMainMenu(true))
                        dispatch(setSelectedSystem('FOT'))
                        dispatch(setOpenChoiceSystem(false))
                    }             
                })}
                >
                    ФОТ
                </button>
                <button
                className="ChoiceSystemMainButton"
                onClick={(async () => {
                    if([roleId.admin, roleId.operatingDirector, roleId.director].includes(User.user.role.id))
                    {
                        await dispatch(setOpenChoiceComponentAR(true))
                    }
                    else
                    {
                        await dispatch(setOpenEnteringDataAR(true))
                    }
                    dispatch(setSelectedSystem('AR'))
                    dispatch(setOpenChoiceSystem(false))
                })}
                onTouchStart={() => {
                    setCancelTouch(false)
                }}
                onTouchMove={() => {
                    setCancelTouch(true)
                }}
                onTouchCancel={() => {
                    setCancelTouch(true)
                }}
                onTouchEnd={(async (event) => {
                    event.preventDefault()
                    if(!CancelTouch)
                    {
                        if([roleId.admin, roleId.operatingDirector, roleId.director].includes(User.user.role.id))
                        {
                            await dispatch(setOpenChoiceComponentAR(true))
                        }
                        else
                        {
                            await dispatch(setOpenEnteringDataAR(true))
                        }
                        dispatch(setSelectedSystem('AR'))
                        dispatch(setOpenChoiceSystem(false))
                    }             
                })}
                >
                    Авансовые отчёты
                </button>
                <button
                className="ChoiceSystemMainButton"
                onClick={(async () => {
                    await dispatch(setOpenRevenueModule(true))
                    dispatch(setSelectedSystem('RevenueModule'))
                    dispatch(setOpenChoiceSystem(false))
                })}
                >
                    Выручка
                </button>
            </div>
        </div>
    )
}
export default ChoiceSystem;